export default {
    "available_in_your_tariff": "Сиздин тарифте жеткиликтүү",
    "market": "Базар",
    "market_of_apps": "Колдонмо базары",
    "most_popular_apps": "Эң популярдуу колдонмолор",
    "new_items": "Жаңы нерселер",
    "recommended_apps": "Сунушталган колдонмолор",
    "setup": "Түн",
    "submit_an_application": "Өтүнмө тапшырыңыз",
    "your_application_was_submitted_our_manager_will_contact_you_soon": "Сурамыңыз жөнөтүлдү, биздин менеджер сиз менен жакын арада байланышат",
}
